import { useQuery } from "@tanstack/react-query";
import React from "react";
import { getUserFactories } from "../services/user";
import Modal from "./Modal";
import {
  Autocomplete,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";

const FactorySelector = ({
  show,
  onClose,
  dismissable,
  onSelect,
  user,
  isInvoiceManagementPage,
}) => {
  const {
    isLoading,
    isError,
    data: factoryList,
  } = useQuery(
    ["factoryListQuery"],
    () =>
      getUserFactories({ userId: user?.email }),
    {
      enabled: user?.id?.length > 1,
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    }
  );

  if (!show) return null;
  
  function getOptions(factoryData) {
    const factoryLists = Object.entries(factoryData.factory_map);
    const options = factoryLists.map(([id, name]) => ({
      label: name,
      id
    }));

    return isInvoiceManagementPage && factoryLists.length > 1
      ? [{ label: 'All Factories', id: 'all' }, ...options]
      : options;
  }

  return (
    <Modal showClose={dismissable} title={"Select factory"} onClose={onClose}>
      {isLoading ? (
        <CircularProgress size={20} />
      ) : isError ? (
        <Typography variant="h6" color={"red"}>
          Error fetching factories
        </Typography>
      ) : (
        <Autocomplete
          disablePortal
          disableClearable
          getOptionLabel={(option) => option.label || ''}
          getOptionKey={(option) =>  option.id || ''}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          sx={{ width: "360px" }}
          onChange={(event, newValue) => {
            if (newValue) {
              onSelect?.([newValue.id, newValue.label]);
              onClose();
            }
          }}
          options={getOptions(factoryList) || []}
          renderInput={(params) => (
            <TextField {...params} label="Search for a factory" />
          )}
        />
      )}
    </Modal>
  );
};

export default FactorySelector;
